import React, { useRef, useEffect, useState } from 'react'
import { useAppSelector } from '../../../../app/hooks'
import { selectedLmsAdminSearch, selectedLmsStatus } from '../../lmsSlice'
import { getSearchResults } from '../../utils'
import { AdminTableProps } from '../../models'
import LinkButton from './LinkButton'
import { IconButton } from '@mui/material'
import KeycloakService from '../../../../utils/keycloakService'
import { SUPER_ADMIN_DELETE } from '../../../../utils/roles'
import DeleteOutlined from '@mui/icons-material/DeleteOutlined'
import {
  create,
  update,
  resultTypeTableHeadings,
  menuValues,
} from '../../constants'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined'
import '../../../administration/admin.scss'

import { DeleteConfirmationDialog } from './DeleteConfirmationDialog'
import { Archive } from './Archive'
import { activeText } from '../../../Radiology/Constants/constants'
import LmsProvenanceView from './LmsProvenanceView'

const ResultTypeTable = ({ data, onEdit }: AdminTableProps) => {
  const searchParam = useAppSelector(selectedLmsAdminSearch)
  const status = useAppSelector(selectedLmsStatus)
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false)

  const [tableData, setTableData] = useState<any>(data)
  const [resultTypeData, setResultTypeData] = useState<any>({})
  let filtered = getSearchResults(tableData, searchParam)
  filtered = filtered?.filter((d) => d?.status === status)
  filtered?.sort?.((a: any, b: any) =>
    a.result_type?.toLowerCase() < b.result_type?.toLowerCase() ? -1 : 1
  )
  const resultTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = resultTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 20}px`
      }
    }

    window.addEventListener('resize', resizeHandler)
    resizeHandler()

    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  useEffect(() => {
    setTableData(data)
  }, [data])

  function handleDeleteDialogOpen(d: any) {
    setDeleteDialog(true)
    setResultTypeData(d)
  }

  function handleCloseDeleteDialog() {
    setDeleteDialog(false)
    setResultTypeData(null)
  }

  return (
    <div
      className='data-table table-fixed admin-table-table-container'
      ref={resultTableContainerRef}
    >
      <table className='data-table table-fixed admin-table relative'>
        <thead style={{ position: 'sticky', top: '0px' }}>
          <tr>
            <th className='table-w-5'>{resultTypeTableHeadings?.id}</th>
            <th>{resultTypeTableHeadings?.resultType}</th>
            <th>{resultTypeTableHeadings?.description}</th>
            <th>{resultTypeTableHeadings?.options}</th>
            <th className='table-w-10'>{resultTypeTableHeadings?.createdBy}</th>
            <th className='table-w-10'>{resultTypeTableHeadings?.updatedBy}</th>
            <th className='table-w-8'>{resultTypeTableHeadings?.actions}</th>
          </tr>
        </thead>
        <tbody>
          {filtered?.length > 0 ? (
            filtered?.map((d: any) => (
              <tr key={d?.id}>
                <td>{d?.id}</td>
                <td>
                  <LinkButton
                    id={d?.id}
                    name={d?.result_type}
                    onClick={onEdit}
                  />
                </td>
                <td>{d?.result_description}</td>
                <td>{d?.options?.join(', ') ?? '-'}</td>
                <td>
                  <LmsProvenanceView
                    mode={create}
                    date={d?.created_date ?? ''}
                    name={d?.created_by ?? '-'}
                  />
                </td>
                <td>
                  <LmsProvenanceView
                    mode={update}
                    date={d?.updated_date ?? ''}
                    name={d?.updated_by ?? '-'}
                  />
                </td>
                <td>
                  <div className='set-action-icons'>
                    {d?.status === activeText ? (
                      <IconButton
                        title='Archive'
                        size='small'
                        onClick={() =>
                          Archive(d, setTableData, menuValues?.ResultType)
                        }
                        disabled={
                          !KeycloakService?.hasRole([SUPER_ADMIN_DELETE])
                        }
                      >
                        <ArchiveOutlinedIcon fontSize='small' />
                      </IconButton>
                    ) : (
                      <IconButton
                        title='un-Archive'
                        size='small'
                        onClick={() =>
                          Archive(d, setTableData, menuValues?.ResultType)
                        }
                        disabled={
                          !KeycloakService?.hasRole([SUPER_ADMIN_DELETE])
                        }
                      >
                        <UnarchiveOutlinedIcon fontSize='small' />
                      </IconButton>
                    )}
                    <IconButton
                      title='Delete'
                      size='small'
                      onClick={() => handleDeleteDialogOpen(d)}
                      disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
                    >
                      <DeleteOutlined fontSize='small' />
                    </IconButton>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className='text-center'>
                No Result Types Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {deleteDialog && (
        <DeleteConfirmationDialog
          openDialog={deleteDialog}
          closeDialog={handleCloseDeleteDialog}
          data={resultTypeData}
          name={resultTypeData?.result_type}
          setData={setTableData}
          item={menuValues?.ResultType}
        />
      )}
    </div>
  )
}

export default ResultTypeTable
